export const STATES = [
  "AK",
  "AL",
  "Alberta",
  "AR",
  "AZ",
  "British Columbia",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "Manitoba",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "New Brunswick",
  "NH",
  "NJ",
  "NM",
  "Nova Scotia",
  "NV",
  "NY",
  "OH",
  "OK",
  "Ontario",
  "OR",
  "PA",
  "Prince Edward Island",
  "Puerto Rico",
  "RI",
  "Saskatchewan",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
]
